import ProductCard from "../components/ProductCard";
import { useEffect, useState } from "react";

function KidsPage() {
  const [kidsProducts, setKidsProducts] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const data = await fetch(`${process.env.REACT_APP_API_URL}/api/products`);
      const products = await data.json();
      setKidsProducts(
        products.filter((product) => product.category === "kids"),
      );
    }
    fetchData();
  }, []);
  return (
    <div>
      <section className="collection-section">
        <h2>Kids' Collection </h2>
        <div className="product-grid">
          {kidsProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </section>
    </div>
  );
}

export default KidsPage;
